import { apiClient } from './apiClient';
import {
  IPrivacySettings,
  INotificationPreferences,
  IUserSettings
} from '../../types/profile.types';

const userSettingsService = {
  /** GET /settings → { success, data: { settings: { privacy, notifications } } } */
  async getSettings(): Promise<IUserSettings> {
    const response = await apiClient.get<{ data: { settings: IUserSettings } }>(
      '/settings'
    );
    return response.data.data.settings;
  },

  /** GET /settings/privacy → { success, data: { privacy: IPrivacySettings } } */
  async getPrivacySettings(): Promise<IPrivacySettings> {
    const response = await apiClient.get<{
      data: { privacy: IPrivacySettings };
    }>('/settings/privacy');
    return response.data.data.privacy;
  },

  /** PATCH /settings/privacy → { success, data: { privacy: IPrivacySettings } } */
  async updatePrivacySettings(
    data: Partial<IPrivacySettings>
  ): Promise<IPrivacySettings> {
    const response = await apiClient.patch<{
      data: { privacy: IPrivacySettings };
    }>('/settings/privacy', data);
    return response.data.data.privacy;
  },

  /** GET /settings/notifications → { success, data: { notifications: INotificationPreferences } } */
  async getNotificationPreferences(): Promise<INotificationPreferences> {
    const response = await apiClient.get<{
      data: { notifications: INotificationPreferences };
    }>('/settings/notifications');
    return response.data.data.notifications;
  },

  /** PATCH /settings/notifications → { success, data: { notifications: INotificationPreferences } } */
  async updateNotificationPreferences(
    data: Partial<INotificationPreferences>
  ): Promise<INotificationPreferences> {
    const response = await apiClient.patch<{
      data: { notifications: INotificationPreferences };
    }>('/settings/notifications', data);
    return response.data.data.notifications;
  }
};

export default userSettingsService;
